import { SELECTED_TEST } from "../constants/testConstants";

// Remove: 'SELECTED_TEST' and 'SET_RESULTS' if not used.

// Existing action creators
export const resultAction = (payload) => ({
  type: 'SET_RESULT',
  payload
});

export const selectedTestaction = (payload) => ({
  type: SELECTED_TEST,
  payload
});

// New action creators for quiz functionality
export const addQuestion = (question) => ({
  type: 'ADD_QUESTION',
  payload: question
});

export const submitQuiz = (quiz) => ({
  type: 'SUBMIT_QUIZ',
  payload: quiz
});

export const setUser = (user) => ({
  type: 'SET_USER',
  payload: user
});
